/**
 * Ancora del clock CRA Art.14 per un thread SRP.
 *
 * La fonte autorevole è il timer SLA del report (subjectRef `srp-report:<id>`), creato alla
 * promozione del Ticket e correggibile dall'analista (PATCH
 * /sla/timers/:id/detected-at). In assenza di timer (report legacy o creati a mano) si
 * ricade su `payload.detectedAt` e infine sulla creazione del report.
 */

import type { SlaTimer, SrpReport } from './types.js';

/** subjectRef del timer SLA associato a un report SRP. */
export function reportSlaSubjectRef(reportId: number): string {
  return `srp-report:${reportId}`;
}

/** Timer SLA del report tra quelli forniti (`undefined` se assente o timer non caricati). */
export function timerForReport(
  report: Pick<SrpReport, 'id'>,
  timers: SlaTimer[] | undefined,
): SlaTimer | undefined {
  const ref = reportSlaSubjectRef(report.id);
  return timers?.find((t) => t.subjectType === 'kev_finding' && t.subjectRef === ref);
}

/** Istante (ms) da cui partono le scadenze del report; `null` se nessuna ancora è valida. */
export function slaAnchorMs(
  report: Pick<SrpReport, 'payload' | 'createdAt'>,
  timer?: Pick<SlaTimer, 'detectedAt'>,
): number | null {
  const raw = timer?.detectedAt ?? report.payload.detectedAt ?? report.createdAt;
  if (!raw) return null;
  const ms = new Date(raw).getTime();
  return Number.isNaN(ms) ? null : ms;
}
